import { Injectable } from '@angular/core';
import { StockItem } from '@app/feature/center-business/stock/search/stock-search.config';

/**
 * Shared service to transfer stock items from stock search
 * to purchase request add component
 */
@Injectable({
  providedIn: 'root',
})
export class PurchaseRequestDataService {
  private selectedStockItems: StockItem[] | null = null;

  /**
   * Set selected stock items from stock search page
   */
  setSelectedStockItems(items: StockItem[]): void {
    this.selectedStockItems = items;
  }

  /**
   * Get and clear selected stock items
   * This method clears the data after reading to prevent
   * items from being added again on subsequent navigations
   */
  getAndClearSelectedStockItems(): StockItem[] | null {
    const items = this.selectedStockItems;
    this.selectedStockItems = null; // Clear after reading
    return items;
  }

  /**
   * Check if there are selected stock items available
   */
  hasSelectedStockItems(): boolean {
    return (
      this.selectedStockItems !== null && this.selectedStockItems.length > 0
    );
  }
}

